export const formatNumberText = (number, text) => {
  return `${number || "No"} ${text}${number > 1 ? "s" : ""}`;
};
